module.exports = __webpack_public_path__ + "static/media/running.74deea72.jpg";